import * as React from 'react';
import * as style from '../../NewbuildingItem.css';
import {
  INewbuildingFromTheBuilderSchema,
  // tslint:disable-next-line:max-line-length
} from '../../../../repositories/newbuilding-card/entities/newbuilding_from_the_builder/NewbuildingFromTheBuilderSchema';

type TAddressProps = Pick<INewbuildingFromTheBuilderSchema, 'address' | 'undergroundName'>;

export const Address: React.FC<TAddressProps> = props => {
  const { address, undergroundName } = props;

  if (!address || undergroundName) {
    return null;
  }

  return <div className={style['address']}>{props.address}</div>;
};
